import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { MapControlsState } from '../slice';

export const mapControlsSelector = rootStateBranchSelector('mapControls');

export function useMapControlsSelector(): MapControlsState {
  return useReduxSelector(mapControlsSelector);
}
